import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  tpTitle: 'Tell us about your company',
  tpSubtitle:
    'Please enter accurate information to avoid delays in the approval of your account.',
  tpGoodsServices: 'What is the predominant activity of your company?',
  tpGoodsServicesPlaceholder:
    'e.g.: Exportations of avocados / Software development',
  tpBusinessPromotion:
    'How do you promote your business and gain your customer base?',
  tpBusinessPromotionPlaceholder:
    'e.g.: Online advertising and strategic alliances',
  tpFundsSource: 'Source of funds for your business',
  tpFundsSourcePlaceholder: 'e.g.: Bank loans, sales made',
  tpFundsSource1: 'Business income (sale of products or services)',
  tpFundsSource2: 'Contract collections',
  tpFundsSource3: 'Partner or shareholder contributions',
  tpFundsSource4: 'Capital increases or loans from partners to the company',
  tpFundsSource5: 'External financing (bank loans or credit lines)',
  tpFundsSource6:
    'Government subsidies or support (economic development programs or state and federal support)',
  tpFundsSource7:
    'Income from financial returns or assets (interest, dividends or investment profits)',
  tpAccountUsage: 'How do you plan to use your EFEX account?',
  tpAccountUsagePlaceholder:
    'e.g.: Payroll / Pay suppliers / Collect from customers',
  tpProducts: 'Which of our products are you interested in using?',
  tpProducts1: 'International payments',
  tpProducts2: 'Mass payments',
  tpProducts3: 'Forwards',
  tpProducts4: 'USD collection in the U.S.',
  tpProducts5: 'Receive transfers in local currency',
  tpProducts6: 'Multi-currency business accounts',
  tpProducts7: 'Embedded integration (SDK)',
  tpProducts8: 'Payment links',
  tpProducts9: 'Multi-currency accounts associated with a loan',
  tpIncome: 'About your income',
  tpExpenses: 'About your expenses',
  tpTransactionsPerMonth: 'Estimated number of transactions per month',
  tpOperationsVolume: 'Estimated volume of operations per month',
  tpContinue: 'Continue',
  tpError: 'Error',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const TRANSACTIONAL_PROFILE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    tpTitle: 'Cuéntanos sobre tu empresa',
    tpSubtitle:
      'Por favor, ingresa información precisa para evitar retrasos en la aprobación de tu cuenta.',
    tpGoodsServices: '¿Cuál es la actividad preponderante de la empresa?',
    tpGoodsServicesPlaceholder:
      'Ej.: Exportaciones de aguacates / Desarrollo de software',
    tpBusinessPromotion:
      '¿Cómo promocionas tu negocio y ganas tu base de clientes?',
    tpBusinessPromotionPlaceholder:
      'Ej.: Publicidad en línea y alianzas estratégicas',
    tpFundsSource: 'Fuente de fondos de tu negocio',
    tpFundsSourcePlaceholder: 'ej.: Créditos bancarios, ventas realizadas',
    tpFundsSource1:
      'Ingresos propios de negocio (venta de productos o servicios)',
    tpFundsSource2: 'Cobros por contratos',
    tpFundsSource3: 'Aportaciones de socios o accionistas',
    tpFundsSource4:
      'Aumentos de capital o préstamos de los socios a la empresa',
    tpFundsSource5:
      'Financiamiento externo (créditos bancarios o líneas de crédito)',
    tpFundsSource6:
      'Subsidios o apoyos gubernamentales (programas de fomento económico o apoyos estatales y federales)',
    tpFundsSource7:
      'Ingresos por rendimientos financieros o activos (intereses, dividendos o utilidades de inversiones)',
    tpAccountUsage: '¿Cómo pretendes utilizar tu cuenta EFEX?',
    tpAccountUsagePlaceholder:
      'Ej.: Pago de nómina / Pago a Proveedores / Cobro a clientes',
    tpProducts: '¿Cuál de nuestros productos te interesa utilizar?',
    tpProducts1: 'Pagos internacionales',
    tpProducts2: 'Pagos masivos',
    tpProducts3: 'Forwards',
    tpProducts4: 'Recaudo en USD en EE. UU.',
    tpProducts5: 'Recibir transferencias en moneda local',
    tpProducts6: 'Cuentas empresariales en múltiples monedas',
    tpProducts7: 'Integración embebida (SDK)',
    tpProducts8: 'Links de pago',
    tpProducts9: 'Cuentas multimoneda asociadas a un préstamo',
    tpIncome: 'Sobre tus ingresos',
    tpExpenses: 'Sobre tus egresos',
    tpTransactionsPerMonth: 'Número de transacciones estimadas por mes',
    tpOperationsVolume: 'Volumen de operaciones estimadas por mes',
    tpContinue: 'Continuar',
    tpError: 'Error',
  },
};

export default TRANSACTIONAL_PROFILE_LABELS;
